export enum DischargeResult {
  Success,
  Died,
  Moved
}
